import { useAppContext } from 'app/AppContext';
import DefaultConsultView from 'components/form/DefaultConsultView'
import { fetchArray } from 'entity';
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import _ from 'lodash'

export default function DefaultEntityConsult({ EntityClass, titulo, updatedValues, extraFilter, extraQuery, routeForm, ...othersProps }) {
    const navigate = useNavigate();
    const { useSetTitle, setActionsView } = useAppContext();
    const [listData, setListData] = useState([])
    const [loading, setLoading] = useState(true)
    useSetTitle(titulo)

    const loadOptions = useCallback(async () => {
        // Carrega apenas uma vez.
        if (listData.length === 0) {
            let query = await EntityClass.query();

            if (extraQuery) {
                query = extraQuery(query);
            }

            let result = await fetchArray(query.get());
            // let result = await fetchArray(EntityClass.getAll())


            if (updatedValues?.length) {

                // lista de campos a serem atualizados se baseando em uma entidade
                for (let i = 0; i < updatedValues.length; i++) {
                    const resultUpdatedField = await fetchArray(updatedValues[i].entityValue.getAll())
                    let path = updatedValues[i].field

                    // atualizando campo
                    for (let j = 0; j < result.length; j++) {
                        if (result[j]) {
                            for (let k = 0; k < resultUpdatedField.length; k++) {
                                if (_.get(result[j], path)?.uid === resultUpdatedField[k]?.uid) {
                                    _.set(result[j], path, resultUpdatedField[k])
                                }
                            }
                        }
                    }
                }
            }

            if (extraFilter) {
                result = await extraFilter(result)
            }

            setListData(result)
            setLoading(false)
        }
    }, [EntityClass, extraFilter, listData.length, updatedValues]);

    useEffect(() => {
        loadOptions();
    }, [loadOptions]);

    useEffect(() => {
        const actions = [
            {
                uid: "novoForm",
                text: "Novo",
                iconName: "Add",
                sequence: "10",
                action: () => {
                    navigate("/" + routeForm);
                },
            },

        ];

        setActionsView(actions);

        return () => {
            setActionsView([]);
        };
    }, [navigate, routeForm, setActionsView]);
    return (
        <DefaultConsultView
            loading={loading}
            columns={EntityClass.searchColumns}
            values={listData}
            onRowClick={(item) => {
                // console.log('onRowClick item', item)
                navigate("/" + routeForm + "?uid=" + item.id)
            }}
            {...othersProps}
        />
    )
}
